import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  showAlertNotification
} from './actions';
import {
  selectAlert
} from './selectors';

import AlertsContext from '../AlertsContext';

// COMPONENTES STATELESS:
import NotificationAlert from '../../../components/NotificationAlert';

import './style.scss';

/**
 * HOC para agregar el componente de notificaciones de alertas
 * y proveer el contexto para ser ejecutado.
 *
 * @param {React.Component|Function} WrappedComponent Componente
 * @returns {React.Component} Componente
 */
export default (WrappedComponent) => {

  /**
   *
   *
   * @class AlertHOC
   * @extends {React.Component}
   */
  class AlertHOC extends React.Component {
    constructor(props) {
      super(props);

      this.handleShowAlert = this.handleShowAlert.bind(this);
      this.handleDismissAlert = this.handleDismissAlert.bind(this);
    }

    /**
     * Envía una notificación de alerta.
     *
     * @param {NotificationAlert.PropTypes} alertProps Props de la notifiación de alerta
     * @returns {undefined} no data
     * @memberof AlertHOC
     */
    handleShowAlert(alertProps) {
      const { actions } = this.props;

      actions.showAlertNotification({
        show: true,
        props: alertProps
      });
    }

    /**
     * Handlea el evento al cerrar la notificación
     *
     * @returns {undefined} no data
     * @memberof AlertHOC
     */
    handleDismissAlert() {
      const { actions } = this.props;

      actions.showAlertNotification({
        show: false,
        props: {}
      });
    }

    render() {
      const { alert } = this.props;

      return (
        <AlertsContext.Provider value={{
            isShown: alert.show,
            showAlert: this.handleShowAlert
          }}
        >
          { alert.show
            && (<div className="notification-alert-container">
              <NotificationAlert
                color={alert.props.color}
                headText={alert.props.headText}
                message={alert.props.message || 'none'}
                onDismiss={this.handleDismissAlert}
              />
                </div>)
          }
          <WrappedComponent
            {...this.props}
          />
        </AlertsContext.Provider>
      );
    }
  }

  AlertHOC.propTypes = {
    alert: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  };

  const mapStateToProps = (state) => ({
    alert: selectAlert(state)
  });

  const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
      showAlertNotification
    }, dispatch)
  });

  return connect(mapStateToProps, mapDispatchToProps)(AlertHOC);
};



// WEBPACK FOOTER //
// ./src/containers/WithNotifyAlert/NotifyAlertProvider/index.js